import { z } from 'zod';

import type { MenuTreeItem } from '@/shared/types/machine.types';
import { pictureSchema } from '@/shared/validation/fetch.validation';

export const machineDetailsSchema = z.object({
  power: z.string().optional(),
  weight: z.string().optional(),
  workingWidth: z.string().optional(),
});

export const machineListResultSchema: z.ZodType<MenuTreeItem[]> = z.array(
  z.object({
    id: z.number(),
    ident: z.string().nullable().optional(),
    title: z.string().nullable().optional(),
    description: z.string().nullable().optional(),
    image: z.string().nullable().optional(),
    picture: pictureSchema.nullable().optional(),
    price: z.number().nullable().optional(),
    items: z.lazy(() => machineListResultSchema).optional(),
    details: machineDetailsSchema.optional(),
  }),
);

export const machineSchema = z.object({
  id: z.number(),
  ident: z.string().nullable().optional(),
  title: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
  price: z.number().nullable().optional(),
  picture: pictureSchema.nullable().optional(),
  details: machineDetailsSchema.optional(),
});

export const machineSidegroupSchema = z.object({
  id: z.number(),
  ident: z.string().nullable().optional(),
  title: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
  picture: pictureSchema.nullable().optional(),
  machines: z.array(machineSchema).optional(),
  details: machineDetailsSchema.optional(),
});

export const machineSubgroupSchema = z.object({
  id: z.number(),
  ident: z.string().nullable().optional(),
  title: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
  picture: pictureSchema.nullable().optional(),
  sidegroups: z.array(machineSidegroupSchema).optional(),
  details: machineDetailsSchema.optional(),
});

export const machineGroupSchema = z.object({
  id: z.number(),
  ident: z.string().nullable().optional(),
  title: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
  picture: pictureSchema.nullable().optional(),
  subgroups: z.array(machineSubgroupSchema),
  details: machineDetailsSchema.optional(),
});

export const machineGroupsSchema = z.array(machineGroupSchema);
